import { OutboundLink } from "gatsby-plugin-google-analytics"
import React, { useState } from "react"
import { Col, Row, Carousel } from "react-bootstrap"
import { whatsappURL } from "./Layout"

export default function ProductDetail({
  image,
  title,
  stock,
  bahan,
  price,
  ukuran,
  onSale,
  html,
  imageTwo,
}) {
  const [index, setIndex] = useState(0)

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex)
  }
  return (
    <Row>
      <Col md={6}>
        <div className="product-image">
          <Carousel activeIndex={index} onSelect={handleSelect}>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={`/products/${image}`}
                alt="First slide"
              />
            </Carousel.Item>
            {imageTwo.length > 0 && (
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={`/products/${imageTwo}`}
                  alt="Second slide"
                />
              </Carousel.Item>
            )}
          </Carousel>
        </div>
      </Col>
      <Col md={6}>
        <h1 className="font-weight-800 font-style-italic">{title}</h1>
        <div className="d-flex justify-content-between">
          <p>Stock: {stock}</p>
          <p>Bahan: {bahan}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p>
            Harga normal: <s>{price}</s>{" "}
          </p>
          <p>Ukuran: {ukuran}</p>
        </div>
        <p className="font-style-italic font-weight-bold text-danger h5">
          On Sale : {onSale}
        </p>
        <div className="mt-3" dangerouslySetInnerHTML={{ __html: html }}></div>
        <div className="text-center text-md-left">
          <OutboundLink
            className="btn btn-danger btn-lg"
            style={{ padding: "0.7em 1em" }}
            target="_blank"
            href={`${whatsappURL}Halo%20kak%2C%0A%0AApakah%20stok%20kaos%20developernya%20masih%20ada%20%3F%20Saya%20mau%20pesan%20${title}`}
          >
            Lanjutkan ke pembayaran
          </OutboundLink>
        </div>
      </Col>
    </Row>
  )
}
